class searchDrawerTrigger extends HTMLElement {
  constructor() {
    super();
    this.focusElement = null;
  }

  connectedCallback() {
    this.searchDrawer = document.querySelector('#search-drawer-model');
    this.addEventListener("click", this.openDrawer.bind(this));
    this.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        this.openDrawer(event);
      }
    });
  }

  openDrawer(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!this.searchDrawer) {
      this.searchDrawer = document.querySelector('#search-drawer-model');
    }
    if (!this.searchDrawer) return;

    this.searchDrawer.classList.add("is-visible");
    document.body.classList.add("overflow-hidden");

    const input = this.searchDrawer.querySelector('input[type="search"], input[type="text"]');
    if (input) {
      requestAnimationFrame(() => {
        setTimeout(() => {
          input.focus();
          input.select?.();
        }, 100);
      });
    }

    setTimeout(() => {
      this.focusElement = event?.target || this;
      if (this.searchDrawer && typeof trapFocusElements === "function") {
        trapFocusElements(this.searchDrawer, input);
      }
    }, 300);
  }
}

customElements.define("search-drawer", searchDrawerTrigger);

class searchModalDialog extends HTMLElement {
  constructor() {
    super();
    this.suggestionsContent = this.querySelector('[data-suggestion-content]');
    this.resultsContainer = this.querySelector('[data-predictive-search-body]');
    this.loadingContainer = this.querySelector('[data-loading-content]');
    this.clear = this.querySelector('[data-clear-input]');
    this.input = this.querySelector('input[type="search"]');
  }

  connectedCallback() {
    this.closeBtns = this.querySelectorAll('[data-drawer-close]');
    this.closeBtns.forEach((closeBtn) => {
      closeBtn.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.closeDrawer();
      });
    });

    if (this.input) {
      this.input.addEventListener(
        'input',
        this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );

      if (this.clear) {
        this.clear.addEventListener('click', (event) => {
          event.preventDefault();
          this.input.value = '';
          this.input.dispatchEvent(new Event("input", { bubbles: true }));
          this.input.focus();
        });
      }
    }

    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  closeDrawer(event) {
    if (event) {
      event.preventDefault?.();
      event.stopPropagation?.();
    }
    this.classList.remove("is-visible");
    document.body.classList.remove("overflow-hidden");
    const searchItem = document.querySelector("search-drawer");
    if (searchItem) {
      searchItem.focus?.();
    }
    if (typeof removeTrapFocus === "function") {
      removeTrapFocus();
    }
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.closeDrawer(event);
    }
  }

  debounce(fn, delay) {
    let timer = null;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    };
  }

  onChange() {
    this.searchTerm = this.input.value.trim();
    if (this.searchTerm === '') {
      if (this.resultsContainer) {
        this.resultsContainer.classList.add('hidden');
        this.resultsContainer.innerHTML = '';
      }
      if (this.loadingContainer) {
        this.loadingContainer.classList.add('hidden');
      }
      if (this.suggestionsContent) {
        this.suggestionsContent.classList.remove('hidden');
      }
    } else {
      if (this.suggestionsContent) {
        this.suggestionsContent.classList.add('hidden');
      }
      if (this.loadingContainer) {
        this.loadingContainer.classList.remove('hidden');
      }
      this.getSearchResults();
    }
  }

  getSearchResults() {
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.searchTerm)}&resources[options][unavailable_products]=show&resources[options][fields]=title,body,product_type,variants.title,vendor,tag&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          console.error('predictive search error', response.status);
        }
        return response.text();
      })
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const wrapper = parsed.querySelector('[data-result-wrapper]');
        if (wrapper && this.resultsContainer) {
          this.resultsContainer.innerHTML = wrapper.innerHTML;
          this.resultsContainer.classList.remove('hidden');
        }
        if (this.loadingContainer) {
          this.loadingContainer.classList.add('hidden');
        }
      })
      .catch((error) => {
        if (error?.code === 20) {
          return;
        }
        console.error(error);
      });
  }
}

customElements.define("search-modal-dialog", searchModalDialog);

class predictiveSearchTab extends HTMLElement {
  constructor() {
    super();
    this.searchDrawerModel = this.closest('#search-drawer-model');
    if (!this.searchDrawerModel) return;
    this.activeTab = this.searchDrawerModel.querySelector('.predictive-search-tab.is-active');
    this.activeTabContent = this.searchDrawerModel.querySelector('.predictive-search-tab-item.active');
    this.tabs = this.querySelectorAll('.predictive-search-tab');
    Array.from(this.tabs).forEach((tab) => {
      if (tab.classList.contains('is-active')) return;
      tab.addEventListener("click", (event) => {
        event.preventDefault();
        this.tabContent = this.searchDrawerModel.querySelector(tab.dataset.tab);
        if (this.tabContent) {
          this.closeExisting();
          tab.classList.add('is-active');
          this.tabContent.classList.add('is-active');
          this.tabContent.style.display = 'block';
          this.activeTab = tab;
          this.activeTabContent = this.tabContent;
        }
      });
    });
    if (this.tabs.length > 0) {
      this.tabs[0].click();
    }
  }

  closeExisting() {
    if (this.activeTab) {
      this.activeTab.classList.remove('is-active');
    }
    if (this.activeTabContent) {
      this.activeTabContent.classList.remove('is-active');
      this.activeTabContent.style.display = 'none';
    }
  }
}

customElements.define("predictive-search-tab", predictiveSearchTab);


